<template>
<!-- 批量导入 -->
    <div class="batch-dialog">
        <el-dialog
            class="dialog-import"
            title="批量导入"
            :visible.sync="show"
            width="800px"
            :before-close="handleClose">
            <div v-if="dialogSteps==1" class="import-updata">
                <el-row>
                    <el-col :span='10'>
                        <el-upload
                            action
                            :show-file-list="false"
                            accept=".xls,.xlsx"
                            :http-request="uploadExcel"
                            ref="loadXlsx">
                            <el-button class="upFile" size="small">选择文件</el-button>
                            <span>{{fileName}}</span>
                        </el-upload>
                    </el-col>
                    <el-col :span='14'>
                        <el-button class="excel-down" size="small" @click="downTemplate">Excel模板下载</el-button>
                        <span class="tip">注意：最多导入20000条医案</span>
                    </el-col>
                </el-row>
                <el-form class="form-data">
                    <el-form-item label="表格："  label-width="80px">
                        <div class="data-table">
                            <p class="radio-cont" v-for="(item,index) in tadioData" :key="index">
                                <el-radio v-model="data_radio" :label="index">{{item}}</el-radio>
                            </p>
                        </div>
                    </el-form-item>
                </el-form>
            </div>

            <!-- table -->
            <div v-if="dialogSteps==2" class="import-table">
                <div class="table-cont">
                    <importTable :tableInfo="tableInfo"></importTable>
                </div>
            </div>
            <!-- 字段对比 -->
            <div v-if="dialogSteps==3" class="import-table import-overflow-x">
                <div class="table-contrast">
                    <div class="table-title">
                        <p class="title-tr">源字段</p>
                        <p class="title-tr">目标字段</p>
                    </div>
                    <el-form>
                        <el-form-item v-for="(item,itemIndex) in targetForm" :label="item.label" label-width="50%" :key="itemIndex">
                            <el-select size="small" v-model="item.value">
                                <el-option v-for="(item,index) in titleList" :key="index" :value="item" :label="item">{{ item }}</el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
             <!-- table -->
            <div v-if="dialogSteps==4" class="import-table">
                <div class="table-cont">
                    <importTable :tableInfo="titleMapInfo"></importTable>
                </div>
                
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="dialogSteps>1" @click="previous_click" type="primary" class="medical-btn">上一步</el-button>
                <el-button type="primary" @click="next_click" class="medical-btn">下一步</el-button>
            </span>
        </el-dialog>
        <!-- 确认映射数据 -->
        <modelTip :ok="'确定'"  :show.sync="isAddModel" @ok='flag_clcik'>
            <div slot="content" >
                <p>所有字段都完成了映射,确认要进入下一步吗?</p>
            </div>
        </modelTip>

         <!-- 录入的选择医案库 -->
        <!-- <div v-if='source=="entry"'> -->
        <chooseMedical :show.sync="isEntry"  @save='checkOrigin'></chooseMedical>
        <!-- </div> -->

        <!-- 追加 -->
        <modelTip :ok="'确定'" :show.sync="isFlagModel" @ok='add_sure'>
            <div slot="content" >
                <el-radio-group v-model="flag" >
                    <el-radio label="1">追加数据</el-radio>
                    <el-radio label="2">替换数据</el-radio>
                </el-radio-group>
            </div>
        </modelTip>
       
        
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import {getExcel,saveExcel,downloadTemplate,checkOriginById} from '../../io/api.js'
import importTable from './import_table.vue'
import modelTip from './model_tip.vue'
import chooseMedical from "./choose_medical.vue"
// import fileDownload from 'js-file-download'
export default {
    props: ['show','type','source'],
    components: {
        importTable,
        modelTip,
        chooseMedical
    },
    data () {
        return {
            isFlagModel:false,
            // isShowModel:false,
            isAddModel:false,
            isFlagModel:false,
            isEntry:false,
            fileName:'未选择任何文件',
            data_radio:'',
            tadioData:[],//导入的sheep
            dialogSteps:1,
            targetForm:[
                {label:'患者编号',value:''}	,
                {label:'姓名',value:''}	,
                {label:'性别',value:''}	,
                {label:'年龄',value:''},
                {label:'职业',value:''}	,
                {label:'就诊日期',value:''}	,
                {label:'诊次',value:''}	,
                {label:'既往史',value:''}	,
                {label:'并发症',value:''}	,
                {label:'临床表现',value:''}	,
                {label:'舌质',value:''}	,
                {label:'舌苔',value:''}	,
                {label:'脉象',value:''}	,
                {label:'医学检查',value:''}	,
                {label:'西医疾病',value:''}	,
                {label:'中医疾病',value:''}	,
                {label:'中医证候',value:''}	,
                {label:'治法',value:''}	,
                {label:'方剂名称',value:''}	,
                {label:'中药组成',value:''},
                {label:'用法',value:''},
                {label:'其他方药疗法',value:''},
                {label:'针灸疗法',value:''},
                {label:'穴位',value:''},
                {label:'按摩疗法',value:''},
                {label:'西医疗法',value:''},
                {label:'其他疗法',value:''},
                {label:'综合疗效',value:''},
                {label:'医师姓名',value:''},
                {label:'医案原文',value:''},
                {label:'医案来源',value:''},
                {label:'备注',value:''}	,
            ],
            excelData:[],//存导入数据
            tableInfo:[],//导入的table数据
            titleList:[],//对比字段
            titleMap:{},//字段处理
            newTitleMap:{},
            titleMapInfo:[],//更新后的map数据
            flag:0,
            recordId:'',//录入时候的医案库ID
        }
    },
    computed: {
        ...mapState(['storeId','medicalDeleteList','searchName','pageInfo',])
    },
    methods: {
        ...mapActions(['getRecord_list','']),
        saveLibraryList(id){
            if(this.isEntry){
                this.isAddModel=true;
            }
            
        },
        handleClose(){
            this.$emit('update:show',false)
            this.initData();
        },
        // 上传文件
        uploadExcel(param) {
            this.initData();
            let formData = new FormData();
            formData.append("file", param.file);
            getExcel(formData).then((res) => {
                this.fileName = param.file.name;
                if(res.data&&res.data.data){
                    let dataInfo =res.data.data;
                    this.tadioData = Object.keys(res.data.data);
                    this.tadioData.forEach(item => {
                        let obj={
                            name:item,
                            info:dataInfo[item]
                        }
                        this.excelData.push(obj)
                    });

                }else{
                    this.$message.error(res.data.msg||'请求失败～');
                }
            });
        },
        initData(){
            this.fileName='未选择任何文件';
            this.data_radio='';
            this.tadioData=[];
            this.dialogSteps=1;
            this.targetForm.forEach(item=>{
                item.value=""
            })
            this.excelData=[];
            this.tableInfo=[];
            this.titleMap={};
            this.titleMapInfo=[];
            this.newTitleMap = {};
            this.flag=0;
            this.isAddModel=false;
            this.isFlagModel=false;
            // this.recordId =''
        },
        // 下载模板
        downTemplate(){
            let strUrl = `https://www.yiankb.com/chuan-cheng/yacj/downloadTemplate`;
            window.open(strUrl); 
        },
        setTableInfo(){
            let infoData = this.excelData[this.data_radio];
            this.titleList =  infoData.info.titleList;
            this.titleMap =infoData.info.titleMap
            let arr = [];
            this.titleList.forEach(item=>{
                for(const key in this.titleMap){
                    if(item==key){
                        let obj={
                            title:item,
                            list:this.titleMap[key]
                        }
                        arr.push(obj)
                    }
                   
                }
            })
            this.tableInfo = arr;
            this.setFormTitle();
        },

        // 字段对比数据处理
        setFormTitle(){
            this.titleList.forEach(item=>{
                this.targetForm.forEach(label=>{
                    if(item==label.label.trim()){
                        label.value = item;
                    }
                })
            })
        },
        // 对比后的table数据
        setMap(){
            let arr = [];
            this.targetForm.forEach(item=>{
                for(const key in this.titleMap){
                    if(item.label.trim()==key){
                        let obj={
                            title:item.label,
                            list:this.titleMap[item.value.trim()],
                        }
                        arr.push(obj)
                    }
                }
            })
            this.titleMapInfo = arr;
            // map数组转map格式
            let obj={}
            
            arr.forEach(item => {
                let key = item.title;
                obj[key] = item.list;
            })
            this.newTitleMap = obj;
        },
        // 下一步
        next_click(){
            if(this.dialogSteps==1){
                if(this.data_radio.toString()==''){
                    this.$message.error("请选择后在操作！");
                    return
                }
                this.setTableInfo();
            }else if(this.dialogSteps==2){
                // console.log(this.targetForm)
            }else if(this.dialogSteps==3){
                this.setMap();
                // this.isAddModel = true
            }
            if(this.dialogSteps<4){
                this.dialogSteps+=1;
                
            }else if(this.dialogSteps==4){
                this.isAddModel = true;
            }
        },
        // 上一步
        previous_click(){
            this.dialogSteps-=1;
        },
        // 选择flag
        flag_clcik(){
            if(this.source=='entry'){
                this.isEntry = true;
            }else{
                this.isFlagModel = true;
            }
            
        },
        // 选择医案库
        checkOrigin(id) {
            this.recordId=id;
            checkOriginById({storeId: this.recordId}).then(res=>{
                let data = res.data;
                if (data.code == 0) {
                    this.isEntry = false;
                    this.isFlagModel = true;
                }else{
                    this.$message.error(data.msg||'请求失败～')
                }
            })
        },
        // 保存请求
        add_sure(){
            let reqData = this.excelData[0].info;
            if(this.flag==''){
                this.$message.error("请选择数据处理方式！");
                return
            }
            let params = {
                bztitleList:reqData.bztitleList,
                dataLength:reqData.dataLength,
                datas:reqData.datas,
                flag:this.flag,
                saveList:reqData.saveList,
                storeId:this.storeId,
                titleList:reqData.titleList,
                titleMap:this.newTitleMap,
            }
            // 医案录入里的批量导入
            if(this.source=='entry'){
                params.storeId=this.recordId
            }
            saveExcel(params).then(res=>{
                let data = res.data;
                if(data && data.code==0){
                    this.initData()
                    this.$emit('update:show',false)
                    this.$message({
                        message:'导入数据成功！',
                        duration: 2000,
                        type: 'success'
                    });
                    if(this.type=='medical'){
                        let searchData = {
                            limit: this.pageInfo.pageSize,
                            page: 1,
                            likeName:this.searchName,
                            storeId:this.storeId
                        };
                        this.getRecord_list(searchData)
                    }
                }else{
                    this.$message.error(data.msg||'请求失败～');
                }
            })
        }
    }
}
</script>

<style lang='less'>
    .batch-dialog{
        .el-form-item{
            width:540px ;
        }
        .el-dialog__header{
            line-height: 24px;
            background-color:#409EFF ;
            font-size: 18px;
            padding: 10px 20px;
            .el-dialog__title{
                color: #fff;
            }
            
        }
        
        .el-dialog__headerbtn{
            top: 12px;
        }
        .el-dialog__close,.el-dialog__headerbtn{
            color: #fff !important;
            // &:hover{
            //      color: #fff;
            // }
        }
        .el-dialog__body{
            padding: 20px 20px 2px;
        }
        .el-dialog__footer{
            padding-top: 0;
        } 
        .el-form-item__label{
            color:#409EFF;
        }
        .audit-reason{
            border-radius: 4px;
            border:2px solid #409EFF;
        }
        .el-textarea__inner{
            border: none;
        }
        .dialog-import{
            .el-dialog__body{
                padding:0
            }
            .el-dialog__footer{
                padding-top:10px;
            }
            .import-updata{
                padding:20px 20px 2px;
                .el-button{
                    color: #606266;
                    // background: #fff;
                    border:1px solid #DCDFE6 ;
                    margin-right: 10px;
                    &:hover{
                        // background: #cfa972;
                        color: #fff;
                    }
                }
                .excel-down{
                    background: #409EFF;
                    color: #fff;
                }
                .tip{
                    color: red;
                }
                .form-data{
                    margin-top: 20px;
                    
                }
                .data-table{
                    border-radius: 4px;
                    border:1px solid #79bbff;
                    padding: 4px 20px 20px;
                    width: 640px;
                    height: 300px;
                    background: #fff;
                    .radio-cont{
                        height: 30px;
                        line-height: 30px;
                    }
                }
            }
            .import-table{
                width: 800px;
                height: 422px;
                overflow: auto;
                &.import-overflow-x{
                    overflow-x:hidden;
                }
                p{
                    text-align: center;
                    line-height: 30px;
                    font-weight: bold;
                }
                .table-cont{
                    // width: 1500px;
                    // height: 800px;
                    background: #fff;
                    .table-info{
                        flex-shrink: 0;
                        .info-title{
                            // background: rgb(247, 248, 250);
                            border-bottom: 1px solid #79bbff;
                            padding: 0 20px;
                            &.list-tr{
                                max-width:2260px;
                            }
                        }                        
                    }
                    .info-list{
                        background: #fff;
                        text-align: center;
                        line-height: 32px;
                        min-height: 32px;
                        border-right: 1px solid #79bbff;
                        border-bottom: 1px solid #79bbff;
                        padding: 0 10px;
                        &.list-width, &.list-tcm{
                            max-width: 960px;
                            white-space:nowrap;//(文字不换行);
                            overflow:hidden;//( 溢出隐藏);
                            text-overflow:ellipsis;//( 文本有溢出加省略号 );
                        }
                        &.list-tcm{
                            max-width:2260px;
                        }
                    }
                }
                
                .el-form-item{
                    width: 798px;
                    border:1px solid #79bbff;
                    border-bottom: none;
                    background: #fff;
                    margin: 0;
                    height: 32px;
                }
                .el-form-item__content{
                    line-height: 32px;
                }
                .el-form-item__label{
                    text-align: center;
                    border-right: 1px solid #79bbff;
                    height: 32px;
                    line-height: 32px;
                    padding: 0;
                }
                .el-select{
                    width: 100%;
                }
                .el-input__inner{
                    text-align: center;
                }
                .table-title{
                    display: flex;
                    // background: rgb(247, 248, 250);
                    .title-tr{
                        width: 50%;
                        
                    }
                }
                .table-contrast{
                    .table-title{
                        height: 30px;
                    }
                    
                }
            }
            
        }
        //确定按钮
        .medical-btn{
            background: #409EFF;
            border-color: #409EFF;
            color: #fff;
        
        }
    } 
</style>